import { ROUTES } from "./siteConfig";

/** Primäre Marketing-Seiten: Positionierung als Digital Marketing / Social Media Agentur */
export const marketingPages = {
  digitaleVermarktung: {
    path: "/digitale-vermarktung",
    title: "Digitale Vermarktung",
    metaTitle: "Digitale Vermarktung für Unternehmen | Digital Marketing Agentur Österreich",
    metaDescription:
      "Digitale Vermarktung für Unternehmen in Österreich: Strategie, Social Media, Online-Präsenz und Website als Teil Ihrer Marketing-Strategie. Aus Kärnten für ganz Österreich.",
    h1: "Digitale Vermarktung – Ihr Partner für sichtbare Unternehmen",
    intro:
      "Digitale Vermarktung verbindet alle Kanäle, über die Sie Kunden erreichen: Website, Social Media, Content und Werbung. Wir entwickeln mit Ihnen eine stimmige Strategie und setzen sie um – so wird Ihre Online-Präsenz zum Wachstumsmotor.",
    sections: [
      {
        title: "Was umfasst digitale Vermarktung?",
        content:
          "Von der Strategie über die Umsetzung bis zur Auswertung: Wir kümmern uns um Ihre Sichtbarkeit im Netz. Dazu gehören eine professionelle Website als Basis, Social Media Marketing, Content-Strategie und – je nach Ziel – Online-Werbung. Websites und Branding sind dabei zentrale Werkzeuge innerhalb Ihrer Marketing-Strategie.",
      },
      {
        title: "Für wen eignet sich digitale Vermarktung?",
        content:
          "Für KMU, Handwerker, Dienstleister und alle Unternehmen in Österreich, die ihre Zielgruppe online erreichen und ihre digitale Präsenz gezielt ausbauen möchten – ohne dabei den Überblick zu verlieren.",
      },
    ],
    faqs: [
      {
        q: "Was ist der Unterschied zwischen digitaler Vermarktung und Webdesign?",
        a: "Webdesign ist die Gestaltung und technische Umsetzung Ihrer Website. Digitale Vermarktung umfasst das Gesamtbild: Strategie, Website, Social Media, Content und Werbung. Die Website ist die Grundlage Ihrer digitalen Marketing-Strategie.",
      },
    ],
    relatedLinks: [
      { label: "Social Media Marketing", path: ROUTES.socialMediaMarketing },
      { label: "Online-Marketing für Unternehmen", path: ROUTES.onlineMarketingUnternehmen },
      { label: "Websites für Unternehmen", path: ROUTES.websitesUnternehmen },
      { label: "Marketing Agentur Kärnten", path: ROUTES.marketingKaernten },
    ],
  },
  socialMediaMarketing: {
    path: "/social-media-marketing",
    title: "Social Media Marketing",
    metaTitle: "Social Media Marketing Agentur Österreich | Social Media Betreuung Unternehmen",
    metaDescription:
      "Social Media Marketing und Social Media Betreuung für Unternehmen in Österreich. Strategie, Content, Community und messbare Ergebnisse – aus Wolfsberg, Kärnten.",
    h1: "Social Media Marketing – Sichtbar bleiben, wo Ihre Kunden sind",
    intro:
      "Social Media Marketing bringt Ihr Unternehmen dorthin, wo Ihre Zielgruppe unterwegs ist: LinkedIn, Instagram, Facebook und mehr. Wir entwickeln Ihre Social Media Strategie, erstellen passenden Content und betreuen Ihre Kanäle strukturiert und nachvollziehbar.",
    sections: [
      {
        title: "Social Media Betreuung für Unternehmen",
        content:
          "Wir übernehmen die planvolle Betreuung Ihrer Social-Media-Kanäle: Inhalte planen, erstellen und veröffentlichen, Community pflegen und Ergebnisse auswerten. So bleibt Ihre Präsenz aktiv und professionell – ohne dass Sie sich täglich selbst darum kümmern müssen.",
      },
      {
        title: "Social Media Strategie",
        content:
          "Welche Plattformen sind für Ihr Unternehmen sinnvoll? Welche Inhalte bringen Sie weiter? Wir legen mit Ihnen Ziele, Zielgruppe und Kanäle fest und bauen eine klare Content- und Redaktionsplanung. So wird Social Media zum Teil Ihrer Gesamtstrategie.",
      },
      {
        title: "Content Marketing im Social Media Kontext",
        content:
          "Guter Content informiert, unterhält und stärkt Ihre Marke. Wir verbinden Content-Ideen mit Ihrem Branding und Ihrer Botschaft – für ein stimmiges Erscheinungsbild auf allen Kanälen.",
      },
    ],
    faqs: [
      {
        q: "Wie funktioniert Social Media Marketing für Unternehmen?",
        a: "Social Media Marketing für Unternehmen umfasst die strategische Nutzung von Plattformen wie LinkedIn, Instagram oder Facebook, um Zielgruppen zu erreichen, Vertrauen aufzubauen und sichtbar zu bleiben. Dazu gehören Content-Planung, regelmäßige Beiträge, Community-Management und Auswertung der Ergebnisse.",
      },
      {
        q: "Wie viel kostet Social Media Betreuung in Österreich?",
        a: "Die Kosten hängen vom Umfang ab: Anzahl der Kanäle, Posting-Frequenz, Erstellung von Texten und Bildern, Community-Management. Wir erstellen nach einer unverbindlichen Beratung ein transparentes Angebot. Eine Übersicht finden Sie auf unserer Seite Social Media Betreuung Kosten Österreich.",
      },
      {
        q: "Welche Plattformen sind für Unternehmen sinnvoll?",
        a: "Das hängt von Ihrer Zielgruppe und Ihrem Geschäft ab: B2B oft LinkedIn, B2C und lokale Reichweite oft Facebook und Instagram. Wir analysieren mit Ihnen, wo Ihre Kunden unterwegs sind, und empfehlen eine fokussierte Auswahl statt auf allen Kanälen präsent zu sein.",
      },
    ],
    relatedLinks: [
      { label: "Digitale Vermarktung", path: ROUTES.digitaleVermarktung },
      { label: "Digitale Markenpräsenz", path: ROUTES.digitaleMarkenpraesenz },
      { label: "Branding", path: ROUTES.serviceBranding },
      { label: "Social Media Agentur Klagenfurt", path: ROUTES.socialMediaKlagenfurt },
      { label: "Social Media Betreuung Kosten Österreich", path: ROUTES.costSocialMedia },
    ],
  },
  onlineMarketingUnternehmen: {
    path: "/online-marketing-fuer-unternehmen",
    title: "Online-Marketing für Unternehmen",
    metaTitle: "Online Marketing für Unternehmen | Online Marketing Agentur Österreich",
    metaDescription:
      "Online-Marketing für Unternehmen in Österreich: Sichtbarkeit, Reichweite und messbare Ergebnisse. Von der Strategie bis zur Umsetzung – Website, Social Media und Werbung.",
    h1: "Online-Marketing für Unternehmen – Sichtbar werden und bleiben",
    intro:
      "Online-Marketing verbindet alle Maßnahmen, mit denen Sie im Internet gefunden werden und Kunden ansprechen: eine professionelle Website als Basis, Suchmaschinen-Optimierung, Social Media und optional bezahlte Werbung. Wir positionieren Sie als Digital Marketing Partner an Ihrer Seite.",
    sections: [
      {
        title: "Online-Präsenz für Unternehmen",
        content:
          "Eine starke Online-Präsenz beginnt mit einer klaren Website – dem Fundament Ihrer digitalen Marketing-Strategie. Darauf aufbauend ergänzen wir Social Media, Content und bei Bedarf Werbekampagnen. So werden Sie dort gefunden, wo Ihre Kunden suchen.",
      },
      {
        title: "Von der Strategie zur Umsetzung",
        content:
          "Wir entwickeln mit Ihnen Ziele und Kennzahlen, wählen die passenden Kanäle und setzen die Maßnahmen um. Transparent, nachvollziehbar und mit Fokus auf Ergebnisse, die zu Ihrem Unternehmen passen.",
      },
    ],
    faqs: [
      {
        q: "Braucht mein Unternehmen Online-Marketing?",
        a: "Wenn Ihre Kunden im Internet nach Lösungen oder Anbietern suchen, ja. Eine professionelle Website und eine aktive, zielgerichtete Präsenz in Social Media erhöhen Ihre Sichtbarkeit und Ihr Vertrauen bei potenziellen Kunden.",
      },
    ],
    relatedLinks: [
      { label: "Digitale Vermarktung", path: ROUTES.digitaleVermarktung },
      { label: "Social Media Marketing", path: ROUTES.socialMediaMarketing },
      { label: "Websites für Unternehmen", path: ROUTES.websitesUnternehmen },
      { label: "Online-Marketing Graz", path: ROUTES.onlineMarketingGraz },
    ],
  },
  digitaleMarkenpraesenz: {
    path: "/digitale-markenpraesenz",
    title: "Digitale Markenpräsenz",
    metaTitle: "Digitale Markenpräsenz | Starke Präsenz für Ihre Marke im Netz",
    metaDescription:
      "Digitale Markenpräsenz für Unternehmen: Website, Social Media und Branding in Einklang. Wir bauen Ihre sichtbare, wiedererkennbare Marke im digitalen Raum auf.",
    h1: "Digitale Markenpräsenz – Ihre Marke konsequent im Netz",
    intro:
      "Digitale Markenpräsenz bedeutet: Ihre Marke ist auf Website, Social Media und allen Touchpoints wiedererkennbar und stimmig. Wir verbinden Branding, Webdesign und Social Media zu einer klaren, professionellen Präsenz.",
    sections: [
      {
        title: "Was gehört zur digitalen Markenpräsenz?",
        content:
          "Eine einheitliche visuelle und inhaltliche Linie über alle Kanäle: Logo, Farben, Tonfall, Bilder und Botschaften. Die Website ist dabei das zentrale Schaufenster; Social Media und Werbung bauen darauf auf. So wirken Sie professionell und vertrauenswürdig.",
      },
    ],
    faqs: [
      {
        q: "Wie unterscheidet sich Markenpräsenz von einer reinen Website?",
        a: "Eine Website allein zeigt Ihre Leistungen. Digitale Markenpräsenz verbindet Website, Social Media und ggf. Werbung zu einem einheitlichen Auftritt – Ihre Marke wird überall wiedererkannt und gestärkt.",
      },
    ],
    relatedLinks: [
      { label: "Branding", path: ROUTES.serviceBranding },
      { label: "Corporate Design", path: ROUTES.serviceCorporateDesign },
      { label: "Social Media Marketing", path: ROUTES.socialMediaMarketing },
      { label: "Websites für Unternehmen", path: ROUTES.websitesUnternehmen },
    ],
  },
};
